<template>
    <span>
    <q-btn flat
           round
           icon="cloud_upload"
           :class="[{published: published, unpublished: unpublished, changed: changed}]"
           @click="publish">
        <q-tooltip>
            Publikuj
        </q-tooltip>
    </q-btn>
    <q-btn v-if="unpublishable && (published || changed)"
           flat
           round
           icon="cloud_upload"
           :class="['rotated']"
           @click="unpublish">
        <q-tooltip>
            Cofnij publikację
        </q-tooltip>
    </q-btn>

    </span>
</template>

<script>
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    export default {
        name: 'PublishButton',
        components: {QTooltip},
        props: ['model', 'what'],
        computed: {
            status () {
                if (this.model && this.model.publicationInformation) {
                    return this.model.publicationInformation.status
                }
            },
            published () {
                return this.status === 'Published'
            },
            unpublished () {
                return this.status === 'Unpublished'
            },
            changed () {
                return this.status === 'Changed'
            },
            unpublishable () {
                return this.$store.state.unpublishableModels.indexOf(this.what) !== -1
            }
        },
        methods: {
            publish () {
                this.$store.dispatch('publish', {
                    what: this.what,
                    item: this.model
                })
            },
            unpublish () {
                this.$store.dispatch('unpublish', {
                    what: this.what,
                    item: this.model
                })

            }
        }
    }
</script>

<style scoped lang="scss">
    .published {
        color: green;
    }

    .unpublished {
        color: gray;
    }

    .changed {
        color: red;
    }

    .rotated {
        transform: rotate(180deg);
    }
</style>